const gw3UserKey = "gw3_user";
const gw2UserKey = "gw2_user";

export function getLocalRefreshToken() {
  const user = JSON.parse(localStorage.getItem(gw3UserKey));

  return user ? user.refresh : null;
}

export function getLocalAccessToken() {
  const user = JSON.parse(localStorage.getItem(gw3UserKey));
  return user?.access;
}

export function updateLocalAccessToken(token) {
  let user = JSON.parse(localStorage.getItem(gw3UserKey));
  if (user) user.access = token;
  localStorage.setItem(gw3UserKey, JSON.stringify(user));
}

export function getUser() {
  return JSON.parse(localStorage.getItem(gw3UserKey));
}

export function setUser(user) {
  localStorage.setItem(gw3UserKey, JSON.stringify(user));
}

export function removeUser() {
  localStorage.removeItem(gw3UserKey);
  // Remove Gw2 User
  localStorage.removeItem(gw2UserKey);
}
